var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 1.6665H6.66667C3.33334 1.6665 1.66667 3.33317 1.66667 6.6665V17.4998C1.66667 17.9582 2.04167 18.3332 2.5 18.3332H13.3333C16.6667 18.3332 18.3333 16.6665 18.3333 13.3332V6.6665C18.3333 3.33317 16.6667 1.6665 13.3333 1.6665Z",
    stroke: "#3F96F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7583 6.53346L6.43334 10.8585C6.26667 11.0251 6.10834 11.3501 6.07501 11.5835L5.84168 13.2335C5.75834 13.8335 6.17501 14.2501 6.77501 14.1668L8.42499 13.9335C8.65832 13.9001 8.98335 13.7418 9.15001 13.5751L13.475 9.25013C14.2167 8.50846 14.575 7.64179 13.475 6.54179C12.375 5.43346 11.5083 5.78346 10.7583 6.53346Z",
    stroke: "#3F96F3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1417 7.1499C10.5083 8.45824 11.5333 9.49157 12.85 9.85824",
    stroke: "#3F96F3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageEdit);
export default __webpack_public_path__ + "static/media/message-edit.51928b2b3b2fc7056095e4fe8a227ab8.svg";
export { ForwardRef as ReactComponent };